Object.assign(diy.core.namespace('diy.module.logo'), {
    logo: require('./Logo'),
    app: require('./logoApp'),
    previewApp: require('./logoPreviewApp')
});



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/logo/js/init.js
 ** module id = 1137
 ** module chunks = 0
 **/